import { Component, OnInit, ViewEncapsulation, Inject, Input, ViewChild } from '@angular/core';
import { TicketInfo } from '../model/ticket.model';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
// import variable PageSize from environment
import {
  environment
} from 'src/environments/environment';
// import function globale
import { Observable, Subscription } from 'rxjs';
import { GlobalService } from '../service/global.service';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { TicketFormComponent } from '../ticket-form/ticket-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-worklist',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './worklist.component.html',
  styleUrls: ['./worklist.component.css']
})
export class WorklistComponent implements OnInit {
  subscriptionLoadTicketList: Subscription
  subscriptionLoadAllTicketList: Subscription
  subscriptionCountTicketList: Subscription
  //Import child component for call function
  @ViewChild(TicketFormComponent) childticketForm: TicketFormComponent;



  //Zone param to child component
    TicketForm: FormGroup
   _ParamProjectCode: string
   _ParamProjectName: string
  Checklist: any
  RoleCode: string = ''
  // Zone Rest API variable
  baseurl: string;

  public hidcouchk: string;

  // Zone pagination variable
  public currentPageNumber: number
  public TicketTotal : number
  public totalPages: number
  public environment: number

  // Ticket List on current role user hand
  TicketList: TicketInfo[]
  AllTicketList: TicketInfo[]
  TicketPromise: Promise<TicketInfo[]>
  //ProjectList: ProjectInfo[]
  //ProjectStatusList: LookupInfo[]

  // Zone Search variable
  isSearchSubmitted: boolean = false;
  txtSearchProjectName: string
  txtSearchTicketId: number
  txtSearchTitle: string

  // Zone Modal
  titlemodal: string
  detailmodal: string


  //flag view detail
  viewdetail: boolean = false

  _ForK2: string;
  _EmpCode: string;
  
  _ParamEmpCode: string;
  _ParamEmpRoleCode: string;
  _ParamTicketId: number;


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private GlobalService: GlobalService, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._ParamEmpRoleCode = this.activatedRoute.snapshot.params.EmpRoleCode;
    this._ParamTicketId = +this.activatedRoute.snapshot.params.Tickid;

    GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit() {
    // set current page number to 1
    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSize;

    this.RoleCode = !!this._ParamEmpRoleCode ? this._ParamEmpRoleCode : localStorage.getItem('EmpRoleCode');
    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
    if (!!this._ForK2 && this._ForK2 == "Y") {
      localStorage.setItem("EmpCode", this._EmpCode);
      localStorage.setItem("EmpRoleCode", this.RoleCode);
    }

     //call function load ticket list on hand current role user
    //this.OnLoadTicketWorklistList();
    console.log('empCode = ', this._EmpCode);

    this.LoadTicketWorklist();
    this.LoadAllTicketWorklist();
     // call function load count all ticket list on hand current role user
     this.OnLoadCountTicketWorklistList();

     // load check list task
     await this.loadChecklist().then((data) => {
       this.Checklist = data
     });

 

    //check Role Validate
    if (this.RoleCode != 'CUSTOMER') {

      this.TicketForm = this.formBuilder.group({
        txtTitle: [null, Validators.required],
        txtDescription: [null, Validators.required],
        txtSysptom: [null, Validators.required],
        txtProblemDate: [null, Validators.required],
        txtAttachCode: [null],
        txtContactperson: [null],
        txtMailcontact: [null],
        txtCCmail: [null],
        ddlTicketStatus: [null, Validators.required],
        ddlTicketState: [null, Validators.required],
        txtDeadline: [null],
        ddlRaiseby: [null],
        //ddlTicketOwner: [null],
        ddlSeverity: [null],
        txtHistoryProgress: [null],
        Checklist: this.createAction(this.Checklist),
      },
        {
          // Used custom form validator 
          validator: [this.validatechecklist(), this.validateMailcontact('txtMailcontact'), this.validateMailcontact('txtCCmail'), this.validateCustomRequire('ddlSeverity')]
        }

      );
    } else {
      this.TicketForm = this.formBuilder.group({
        txtTitle: [null, Validators.required],
        txtDescription: [null, Validators.required],
        txtSysptom: [null, Validators.required],
        txtProblemDate: [null, Validators.required],
        txtAttachCode: [null],
        txtContactperson: [null],
        txtMailcontact: [null],
        txtCCmail: [null],
        ddlTicketStatus: [null],
        ddlTicketState: [null],
        txtDuedate: [null],
        txtDeadline: [null],

        ddlRaiseby: [null],
        //ddlTicketOwner: [null],
        ddlSeverity: [null],
        txtHistoryProgress: [null],
        Checklist: this.createAction(this.Checklist),

      }
        //},
        //  {
        //    // Used custom form validator 
        //    validator: [this.checkdate("txtDateraise", "txtDuedate"), this.checkdate("txtDateraise", "txtTargetCompletionDate")]
        //  }
      );


    }

  }


  // ------------------------------------------------------ Function WOrklist Zone ------------------------------------------------------
  async LoadTicketWorklist() {
    this.subscriptionLoadTicketList = (await this.LoadTicketWorklistList())
      .subscribe(
        data => {
          this.subscriptionLoadTicketList.unsubscribe();
          this.TicketList = data;
          // console.log("TicketList data = ", data);
          
          this.hidcouchk = this.TicketList.length.toString();
          
          if (data.length == 1 && this.txtSearchProjectName == "" && this.txtSearchTicketId != 0 && this.txtSearchTitle == "") {
          
            this.router.navigate(['ticket-detail'], { queryParams: { TicketId: data[0].TicketId } })

          }



        },
        err => {
          console.error('Observer got an error: ' + err)
        },
        () => {
          console.log('Observer got a complete notification')
        }

      )
  }

  async LoadAllTicketWorklist() {
    this.subscriptionLoadAllTicketList = (await this.LoadAllTicketWorklistList())
      .subscribe(
        data => {
          this.subscriptionLoadAllTicketList.unsubscribe();
          this.AllTicketList = data;



        },
        err => {
          console.error('Observer got an error: ' + err)
        },
        () => {
          console.log('Observer got a complete notification')
        }

      )
  }
  // Call Rest api for load ticket list on hand current role user 
  async LoadTicketWorklistList() {
    var auth_token = await this.TokenService.RefreshToken();
     if (!!auth_token) {
       const httpOptions = {
         headers: new HttpHeaders({
           'Content-Type': 'application/json',
           'Authorization': `Bearer ${auth_token}`
         })
       };

       let offset = (this.currentPageNumber - 1) * environment.PageSize;

       let objectjson = {};

       objectjson['ProjectName'] = this.txtSearchProjectName;
       objectjson['TicketId'] = this.txtSearchTicketId;
       objectjson['Title'] = this.txtSearchTitle;
       objectjson['ContactlistEmpCode'] = this.GlobalService.checkUndefinedString(this._EmpCode);
       objectjson['rowFetch'] = environment.PageSize;
       objectjson['rowOFFSet'] = offset;
       objectjson["FlagDelete"] = "N";
       let strjson = JSON.stringify(objectjson);

      //  console.log("gettkwork = ", strjson);

       return this.httpClient
         .post<TicketInfo[]>(this.baseurl + "Ticket/GetTicketWorklist",
           strjson, httpOptions)
     }
  }
  // Call Rest api for load all ticket list on hand current role user 
  async LoadAllTicketWorklistList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      let objectjson = {};

      objectjson['ContactlistEmpCode'] = this.GlobalService.checkUndefinedString(this._EmpCode);
      objectjson["FlagDelete"] = "N";

      if(this._ParamTicketId){
          objectjson["TicketId"] = this._ParamTicketId;
          // objectjson["ProjectCode"] = this._ParamProjectCode;

      // let ticketId: string = this._ParamTicketId.toString();   
      let params = new HttpParams()

       .set('ticketId', this._ParamTicketId.toString())
       .set('contactlistEmpCode', this.GlobalService.checkUndefinedString(this._EmpCode));


        // let strjson = JSON.stringify(objectjson);
        console.log("xxxxxx.....");

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        }),
        params: params
      };

          return this.httpClient
            .get<TicketInfo[]>(this.baseurl + "Ticket/GetTicket",
             httpOptions)
      } else{

        const httpOptions = {
          headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })  
        };

      let strjson = JSON.stringify(objectjson);

      console.log("GetTicketWorklist -- ", strjson);

          return this.httpClient
            .post<TicketInfo[]>(this.baseurl + "Ticket/GetTicketWorklist",
              strjson, httpOptions)
        }
      }

  }

  // Call Rest api for load count all ticket list on hand current role user 
  async LoadCountTicketWorklistList() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let objectjson = {};

      objectjson["ProjectName"] = this.txtSearchProjectName;
      objectjson["TicketId"] = this.txtSearchTicketId;
      objectjson["Title"] = this.txtSearchTitle;
      objectjson["ContactlistEmpCode"] = this.GlobalService.checkUndefinedString(this._EmpCode);
      objectjson["FlagDelete"] = "N";

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "Ticket/GetAllCountTicketWorklist",
          strjson, httpOptions)
        .toPromise()
    }
  }

  //OnLoadTicketWorklistList(traget = null) {

  //  // check call function from change page or onloadfrist
  //  if (traget != null) {
  //    this.LoadTicketUpdatePagination(traget);
  //  }

  //  //call function load ticket list on hand current role user
  //  this.LoadTicketWorklistList().then(data => {
  //    this.TicketList = data;
  //  })
  //}

  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  async OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);

      await this.LoadTicketWorklist();
    } else {
      this.LoadTicketWorklist();
    }
    

  }


  async OnLoadCountTicketWorklistList() {

    //call function load count all ticket list on hand current role user
    await this.LoadCountTicketWorklistList().then(data => {
      this.TicketTotal = data;
      if(this.TicketTotal == 0) this.currentPageNumber = 0;
      this.totalPages = Math.ceil(this.TicketTotal / environment.PageSize);

    }
    )
  }


  //Function Onclick Search
  async OnClickSearchTiketWorklist(flag: boolean = true) {
    this.currentPageNumber = 1; // reset page number
    //call function load ticket list on hand current role user
   // this.OnLoadTicketWorklistList();
    await this.OnLoadListFinished();
    //call function load count all ticket list on hand current role user
    await this.LoadCountTicketWorklistList().then(data => {
      this.TicketTotal = data;
      this.currentPageNumber = this.TicketTotal == 0 ? 0 : 1;
      this.totalPages = Math.ceil(this.TicketTotal / environment.PageSize);
    });

    this.isSearchSubmitted = flag;
  }

  // Function Onclick Cancel
  CancelSearchSection() {
    this.isSearchSubmitted = false;
    this.ClearSearch();
    this.OnClickSearchTiketWorklist(false);
  }

  // function clear search control
  ClearSearch() {
    this.txtSearchProjectName = null
    this.txtSearchTicketId = null
    this.txtSearchTitle = null
    this.isSearchSubmitted = false;
  }

  // Function Update variable abount pagination
  LoadTicketUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  callbackLoadWorklist() {
    //call function load ticket list on hand current role user
   //this.OnLoadTicketWorklistList();
    this.OnLoadListFinished();
    // call function load count all ticket list on hand current role user
    this.OnLoadCountTicketWorklistList();
  }

  // ----------------------------------------------------End Function WOrklist Zone ------------------------------------------------------

// ------------------------------------------------------ Function Ticket Form Zone ------------------------------------------------------
  //Function Update ticket Form
  UpdateticketForm(tragetticket: TicketInfo) {

    // replace param Ticket id
    var newurl = window.location.pathname;
    newurl = newurl.replace(/Tickid=\d*/g, "Tickid=" + tragetticket.TicketId + "");

    if (window.history.replaceState) {
      window.history.replaceState('', '', newurl);
    } else {
      window.history.pushState('', '', newurl);
    }

    // show detail zone
    $('#WorklistZone').hide();
    $('#TicketDetailZone').show();
    // set param for send to child component
    this._ParamProjectCode = tragetticket.ProjectCode;
    this._ParamProjectName = tragetticket.ProjectName;

    this.childticketForm.btnClick_onUpdateTicket(tragetticket.TicketId);

  }


  //Fnction Get Checklist master
  async loadChecklist() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{}";

      console.log(strjson);

      return await this.httpClient.post<any>(this.baseurl + "Checklist/GetChecklist", strjson, httpOptions)
        .toPromise()
    }
  }

  createAction(actionInputs) {
    const arr = actionInputs.map(action => {
      return new FormControl(action.selected || false);
    });
    return new FormArray(arr);
  }


  UpdateValueModal(traget) {
    this.titlemodal = traget.titlemodal;
    this.detailmodal = traget.detailmodal;
  }

// ------------------------------------------------------End Function Ticket Form Zone ------------------------------------------------------

  // ------------------------------------------------------------------- Validate Custom Zone -----------------------------------------------------------------------------------
  // validate checklist
  validatechecklist() {
    return (formGroup: FormGroup) => {
      const checklistcontrol = formGroup.controls['Checklist'];
      const TicketStatuscontrol = formGroup.controls['ddlTicketStatus'];

      if (checklistcontrol.errors && !checklistcontrol.errors.validatechecklist) {
        return;
      }
      // when status eq 4 (Assigned) check if check list must be true at all
      if (TicketStatuscontrol.value == '4') {
        var flagvalidatechecklist = checklistcontrol.value.every((flagchecklist) => { return flagchecklist == true; });
        if (flagvalidatechecklist == false) {
          checklistcontrol.setErrors({ validatechecklist: true });
        } else {
          checklistcontrol.setErrors(null);
        }
      } else {
        checklistcontrol.setErrors(null);

      }

    };
  }

  // validate Mail contact
  validateMailcontact(controlName: string) {
    return (formGroup: FormGroup) => {
      const txtMail = formGroup.controls[controlName];

      if (txtMail.errors && !txtMail.errors.validateMailcontact) {
        return;
      }

      // convert mail contact to array by split ,
      var arraymailcontact = txtMail.value != null && txtMail.value != '' ? txtMail.value.split(',') : [];
      var arraycheckvalidate = [];
      // loop array mail contact
      for (let i = 0; i < arraymailcontact.length; i++) {
        if (this.validateEmail(arraymailcontact[i])) { // check validate email if retrun true
          arraycheckvalidate.push(true); // push true when case is valid
        } else {
          arraycheckvalidate.push(false); // push false when case is not valid
        }
      }

      if (arraycheckvalidate.length > 0) {
        // check if check list must be true at all
        var flagvalidateMail = arraycheckvalidate.every((flagvalidate) => { return flagvalidate == true; });
        if (flagvalidateMail == false) {
          txtMail.setErrors({ validateMailcontact: true });
        } else {
          txtMail.setErrors(null);
        }
      } else {
        txtMail.setErrors(null);

      }



    };
  }

  // validate require control when status not eq New
  validateCustomRequire(controlName: string) {
    return (formGroup: FormGroup) => {
      const txtcontrol = formGroup.controls[controlName];
      const TicketStatuscontrol = formGroup.controls['ddlTicketStatus'];

      if (txtcontrol.errors && !txtcontrol.errors.validateCustomRequire) {
        return;
      }
      // when status not eq 1 (New) and 8 (Closed)
      if (TicketStatuscontrol.value != '1' && TicketStatuscontrol.value != '8') {
        if (txtcontrol.value == '' || txtcontrol.value == null) {
          txtcontrol.setErrors({ validateCustomRequire: true });
        } else {
          txtcontrol.setErrors(null);
        }

      } else {
        txtcontrol.setErrors(null);

      }

    };
  }

  // ------------------------------------------------------------------- End Validate Custom Zone -----------------------------------------------------------------------------------

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

    isOverdue(dateString: string | Date): boolean {
      let today = new Date();
      let deadline = new Date(dateString);

      return deadline < today;
    }
}
